import React, { Fragment, useState, useEffect } from "react";
import Topbar from "../layouts/TopBar";
import Footer from "../layouts/Footer";
import EventResources from "../resources/EventResources";
import UserResources from "../resources/UserResources";
import toast from 'react-hot-toast';
import moment from "moment/moment";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { event } from "jquery";
import Select from 'react-select';
import { connect } from "react-redux";
import { loginSuccess, logout } from "../redux/actions/LoggedInAction";

function EventDetails({isLoggedIn, loggedInUser}){
    const location = useLocation();

    const [events, setEvents] = useState([])
    const [eventId, setEventId] = useState('')
    const [eventVolunteers, setEventVolunteers] = useState([])
    const [users, setUsers] = useState([])
    const [selectedOption, setSelectedOption] = useState({}); // stores the entire user details
    const [availabiltyInfo, setavailabiltyInfo] = useState('');
    const resources = new EventResources()
  
    // Function to handle dropdown change
    const handleDropdownChange = (event) => {
      setSelectedOption(event.value);
    };

    // Function to handle textbox change
    const handleAvailabilityInputChange = (event) => {
        setavailabiltyInfo(event.target.value);

    };


        // Function to handle button clicks
    const handleAddVolunteerButtonClick = () => {

      // Check if event is closed
      if (events.length > 0 && events[0]['event_closed'] === 'True') {
        toast.error("This event is closed and is no longer accepting volunteers")
        return;
      }

      // Check if user is already a volunteer
      const alreadyVolunteer = eventVolunteers.some(volunteer => volunteer['user_id'] === loggedInUser['id']);
        if (alreadyVolunteer) {
            toast.error("You have already volunteered for this event")
            return;
        }

        // confirm volunteering
        if (!window.confirm("Are you sure you want to volunteer for this event?")) {
            return;
        }

      let volunteer = {};
      volunteer['user_id'] = loggedInUser['id']
      volunteer['availabilty_info'] = availabiltyInfo.length > 1 ? availabiltyInfo : 'Fully Available'
      volunteer['event_id'] = Number(eventId)
      resources.post_Volunteers(volunteer).then(res => {
            if (res.error.length < 1) {
                toast.success("Thanks for Volunteering")
                setTimeout(() => {
                    window.location.href = window.location.origin + '/eventsdetails?id='+events[0]['id'];
                  }, 200);
            }else if(res.error === 'Unconfirmed User') {
                toast.error("You can only add yourself as a volunteer")
            }else if(res.error === 'User already Volunteered for this event') {
                toast.error("You have already volunteered for this event")
            }else {
                //toast.error("Operation Failed: " + res.error);
                toast.error("An Issue occured, please retry")
            }
            }).catch((err) => {
                toast.error("Network Error: " + err);
            });


        setTimeout(() => {
            window.location.href = window.location.origin + '/eventsdetails?id='+eventId;
          }, 200);
    };

    // Function to handle button clicks
    const handleDeleteVolunteerButtonClick = () => {
        // confirm if they want to remove themselves as a volunteer
        if (!window.confirm("Are you sure you want to remove yourself as a volunteer for this event?")) {
            return; 
        }
        
      let volunteer = {};
      volunteer['user_id'] = loggedInUser['id']
      volunteer['event_id'] = Number(eventId)
      resources.delete_Volunteer(volunteer).then(res => {
            if (res.error.length < 1) {
                toast.success("You have been removed as a volunteer for this event")
                setTimeout(() => {
                    window.location.href = window.location.origin + '/eventsdetails?id='+events[0]['id'];
                  }, 200);
            }else if(res.error === 'Unconfirmed User') {
                toast.error("You can only remove yourself as a volunteer")
            }
             else {
                //toast.error("Operation Failed: " + res.error);
                toast.error("An Issue occured, please retry")
            }
            }).catch((err) => {
                toast.error("Network Error: " + err);
            });

      setTimeout(() => {
        window.location.href = window.location.origin + '/eventsdetails?id='+eventId;
      }, 200);

    };

    const loadEvent = (eventId) => {
        return resources.get_userSingleEvent(eventId)
    }

    const loadEventVolunteers = (eventId) => {
        return resources.get_adminVolunteers(eventId)
    }

    const loadUsers = () => {
        let userResources = new UserResources()
        return userResources.get_admin()
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        //const searchParamss = queryString.parse(location.search)
        
         const eventId = searchParams.get('id');
         setEventId(eventId)

        loadEvent(eventId).then(response => {
            setEvents(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });

        loadEventVolunteers(eventId).then(response => {
            setEventVolunteers(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });

        loadUsers().then(response => {
            setUsers(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });

    }, []);

    let members = []  //dropdown values is the user information
    users.map((user, index) => (
        members.push({value: user, label: user['firstname'] + " " + user['lastname'] })
    ))
    return(        
        <Fragment>
            <Topbar/>
             <div className="hero-area">
             <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">                    
                        <div className="page-banner-text">
                            <h1 style={{color:"#ffa800"}} className="block-title"><strong>Event Details</strong></h1>                                                      
                        </div>
                    </div>
                </div>
            </div>

            {/* <!--Main Content> */}
            <div id="main-container">
                <div className="content">                    
                    <div className="container">
                    <div className="row">   
                    <div className="grid-item event-grid-item format-standard">
                        
                        {
                            events.length > 0 && ((events[0]['team_members_only'] === 'True' && isLoggedIn) || events[0]['team_members_only'] === 'False') ?
                        
                        <div className="grid-item-inner"><a href={events && events.length > 0 && events[0]['image']} className="media-box" target="_blank">  
                            {events && events.length > 0 && (
                                <img src={events[0]['image']} style={{width: "100%", maxWidth: "800px", height: "clamp(180px, 40vw, 420px)", objectFit: "cover", borderRadius: "8px"}} alt=""/>
                                )}   
                            </a>

                            <div className="spacer-50"></div><div className="spacer-50"></div>
                            <div className="spacer-50"></div><div className="spacer-50"></div>
                            <div className="spacer-50"></div><div className="spacer-50"></div>

                            
                            {events.map((event, idx) => (
                                <div className="grid-item-content" key = {idx} >
                                <span style={{backgroundColor:"#ffa800"}} className="event-date">
                                    <span className="date">{moment(event['event_date']).format('DD')}</span>
                                    <span className="month">{moment(event['event_date']).format('MMM')}</span>  
                                    <span className="year">{moment(event['event_date']).format('YYYY')}</span>
                                </span>
                                
                                <h2 className="post-title"><strong><p style={{color:"#003165"}}>{event['name']}</p></strong></h2>   
                                <h3><span className="meta-data" style={{color:"#ffa800", fontWeight: 'bold', fontSize: 'clamp(15px, 4.5vw, 18px)'}}><strong>Event Start: {moment(event['start_time']).format('dddd, HH:mm')}</strong></span></h3>
                                <div className="spacer-20"></div>
                                <ul className="list-group">                                    
                                    <li className="list-group-item">{event['event_venue']}<span className="badge">Location</span></li>
                                    <li className="list-group-item">{event['number_attendees']}<span className="badge">Attendees</span></li>
                                    <li className="list-group-item">{event['event_requirements']}<span className="badge">Event Requirements</span></li>                                    
                                    { isLoggedIn ? <li className="list-group-item">{event['contact_name'] + " - " + event['phone'] + " - "  + event['email']}<span className="badge">Event Contact</span></li>:<></>}
                                    <li className="list-group-item">{event['other_detail']}<span className="badge">Other details</span></li>
                                    
                                </ul>
                                <div className="spacer-20"></div>

                                {
                                    isLoggedIn ?
                                    <div style={{marginTop: '20px', padding: '18px 20px', backgroundColor: '#003165', borderRadius: '8px'}}>
                                        <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                                            <span style={{color: '#fff', fontWeight: 'bold', fontSize: 'clamp(12px, 3.5vw, 14px)', textTransform: 'uppercase', letterSpacing: '1px'}}>Media Setup Time</span>
                                        </div>
                                        <div style={{marginTop: '6px'}}>
                                            <span style={{color: '#ffa800', fontWeight: 'bold', fontSize: 'clamp(18px, 5vw, 22px)'}}>{moment(event['media_setup_time']).format('dddd, HH:mm')}</span>
                                        </div>
                                    </div>
                                    :<></>
                                }

                            </div>

                            ))}

                        </div>:<><h1 style={{color:"#ffa800"}} className="block-title"><strong>No Access to this Event Details</strong></h1>  </>
                    }
                    </div>
                    </div>

                    <div className="spacer-40"></div>

                    {
                        isLoggedIn ?
                        <div style={{backgroundColor: '#fff', borderRadius: '10px', border: '1px solid #e0e0e0', padding: '20px', marginBottom: '20px'}}>
                            <h3 style={{color: '#003165', margin: '0 0 16px 0'}}>Media Volunteers</h3>
                            {eventVolunteers.length > 0 ?
                            <TableContainer component={Paper} style={{boxShadow: 'none', border: '1px solid #e0e0e0', borderRadius: '8px'}}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow style={{backgroundColor: '#003165'}}>
                                            <TableCell style={{color: '#fff', fontWeight: 'bold'}}>First Name</TableCell>
                                            <TableCell style={{color: '#fff', fontWeight: 'bold'}}>Last Name</TableCell>
                                            <TableCell style={{color: '#fff', fontWeight: 'bold'}}>Availability Info</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {eventVolunteers.map((volunteer, idx) => (
                                        <TableRow key={idx} style={{backgroundColor: idx % 2 === 0 ? '#fff' : '#f8f9fa'}}>
                                            <TableCell>{volunteer['user.firstname']}</TableCell>
                                            <TableCell>{volunteer['user.lastname']}</TableCell>
                                            <TableCell>{volunteer['availabilty_info'] || 'Fully Available'}</TableCell>
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            :
                            <p style={{color: '#999', fontStyle: 'italic', margin: 0}}>No volunteers signed up yet.</p>
                            }
                        </div>
                        : <></>
                    }

                    {
                        isLoggedIn ?
                        <div style={{backgroundColor: '#fff', borderRadius: '10px', border: '1px solid #e0e0e0', padding: '20px', marginBottom: '20px'}}>
                            <h3 style={{color: '#003165', margin: '0 0 8px 0'}}>Volunteer for this Event</h3>
                            {events.length > 0 && events[0]['event_closed'] === 'True' ? (
                                <p style={{color: '#d80000', margin: 0, fontWeight: 'bold'}}>This event is closed and is no longer accepting volunteers.</p>
                            ) : (
                                <>
                                    {loggedInUser && (
                                        <div style={{backgroundColor: '#fff', padding: '15px', borderRadius: '8px', marginBottom: '16px', border: '2px solid #ffa800'}}>
                                            <p style={{margin: 0, color: '#003165'}}>
                                                <strong>Volunteering as:</strong> {loggedInUser.firstname} {loggedInUser.lastname}
                                            </p>
                                        </div>
                                    )}
                                    <p style={{color: '#666', margin: '0 0 16px 0', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>If no additional details are provided, it will be taken that you are available from setup time to event end.</p>
                                    <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'flex-end'}}>
                                        <div style={{flex: '1 1 250px', minWidth: '250px'}}>
                                            <input
                                                type="text"
                                                value={availabiltyInfo}
                                                onChange={handleAvailabilityInputChange}
                                                placeholder="Additional availability info"
                                                style={{width: '100%', padding: '8px 10px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box', fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                            />
                                        </div>
                                        <div style={{display: 'flex', gap: '8px'}}>
                                            <button
                                                onClick={handleAddVolunteerButtonClick}
                                                style={{backgroundColor: '#8ccd80', color: '#003165', padding: '8px 18px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                            >Add</button>
                                            <button
                                                onClick={handleDeleteVolunteerButtonClick}
                                                style={{backgroundColor: '#d80000', color: '#fff', padding: '8px 18px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                            >Remove</button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                        : <></>
                    }

                    <div className="spacer-40"></div>
                    </div>
                </div>
            </div>
            <Footer/>

        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };
    
};

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(EventDetails);